export const assets = {
  logo: 'assets/images/esqyre_logo.svg',
  adminIcon: 'assets/images/profile.png',
  placeHolderLogo: 'assets/images/placeholder.png',
  DashboardIcon: 'assets/images/dashboard_icon.svg',
  DashboardIconNew: 'assets/images/dashboard_icon_new.svg',
  viewIcon: 'assets/images/view_icon.svg',
  editIcon: 'assets/images/edit_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  RevenueIcon: 'assets/images/revenue_icon.svg',
  FinancialIcon: 'assets/images/finance_icon.svg',
  CmsIcon: 'assets/images/cms_icon.svg',
  suggestedPath: 'assets/images/suggested-polyline.svg',
  CategoryIcon: 'assets/images/category_icon.svg',
  depositePolicy: 'assets/images/deposit.png',
  rentalPolicy: 'assets/images/rental.png',
  rentalPolicyGrey: 'assets/images/rental-icon-white.svg',
  depositePolicyGrey: 'assets/images/deposit-icon-white.svg',
  mileagePolicyGrey: 'assets/images/mileage-icon-white.svg',
  fuelPolicyGrey: 'assets/images/fuel-icon-white.svg',
  fuelPolicy: 'assets/images/fuel.png',
  mileageIocn: 'assets/images/mileage-icon.svg',
  gearIcon: 'assets/images/gear.png',
  engineIcon: 'assets/images/engine.png',
  mileagePolicy: 'assets/images/mileage.png',
  depositePolicyWhite: 'assets/images/deposite-white.png',
  rentalPolicyWhite: 'assets/images/rental-white.png',
  fuelPolicyWhite: 'assets/images/fuel-white.png',
  mileagePolicyWhite: 'assets/images/mileage-white.png',
  NotificationIcon: 'assets/images/notification.svg',
  NotificationIconGrey: 'assets/images/notify-icon.svg',
  ReportIcon: 'assets/images/reports_icon.svg',
  searchIcon: 'assets/images/search_icon.svg',
  UsersIcon: 'assets/images/user_icon.svg',
  ContactUsIcon: 'assets/images/contact_Us.svg',
  UsersIconNew: 'assets/images/user_icon_new.svg',
  AnalyticIcon: 'assets/images/analytic_icon.svg',
  AnalyticIconNew: 'assets/images/analytic_icon_new.svg',
  SubAdminIcon: 'assets/images/sub_admin_icon.svg',
  SubAdminIconNew: 'assets/images/sub_admin_icon_new.svg',
  SubscriptionIcon: 'assets/images/subscription_icon.svg',
  ConsentRequestIcon: 'assets/images/consent_request_icon.svg',
  Signature: 'assets/images/signature.jpg',
  CameraIcon: 'assets/images/camera_icon.svg',
  RatingIcon: 'assets/images/rating_icon.svg',
  CarIcon: 'assets/images/car_icon.svg',
  CompanyIcon: 'assets/images/vendor_icon.svg',
  OrganisationIcon: 'assets/images/organisation_icon.svg',
  DriverIcon: 'assets/images/driver_icon.svg',
  ChatIcon: 'assets/images/chat_icon.svg',
  BookingIcon: 'assets/images/booking_icon.svg',
  BookingIconNew: 'assets/images/all_booking_icon.svg',
  createBookingIcon: 'assets/images/createBooking-icon.svg',
  createBookingIconNew: 'assets/images/create-booking-icon.svg',
  ReportingIcon: 'assets/images/reporting_icon.svg',
  logoMin: 'assets/images/logo_min.png',
  noDataFound: 'assets/images/Nodat-found.gif',
  pickupMarker: 'assets/images/pickup-pin.png',
  dropoffMarker: 'assets/images/drop-off-pin.png',
  starIcon: 'assets/images/star.svg',
  pickupIcon: 'assets/images/pickup-pin.png',
  dropOfIcon: 'assets/images/drop-off-pin.png',
  kycIcon: 'assets/images/kyc.png',
  navigator: 'assets/images/navigator.png',
  wareHouseIcon: 'assets/images/warehouse.png',
  locationIcon: 'assets/images/location-pin.png',
  totalClient: 'assets/images/total-clients.svg',
  ChaufferRental: 'assets/images/Chauffeur-Rental.svg',
  selfDrive: 'assets/images/Self-Drive.svg',
  totalEmp: 'assets/images/total-emp.svg',
  stageOnePath: 'assets/images/stage1-polyline.png',
  year: 'assets/images/Year.png',
  fitBags: 'assets/images/fitBags.png',
  type: 'assets/images/Type.png',
  drive: 'assets/images/driveType.png',
  max: 'assets/images/max.png',
  seatIcon: 'assets/images/seat.png',
  gear: 'assets/images/gear.png',
  engine: 'assets/images/engine.png',
  stageTwoPath: 'assets/images/stage2-polyline.png',
  checkIconGreen: 'assets/images/Green_icon.svg',
  checkIconWhite: 'assets/images/check_icon_whie.svg',
  lockIcon: 'assets/images/lock-icon.svg',
  left_arrow: 'assets/images/left-arrow.svg',
  locationMarker: 'assets/images/location-marker.svg',
  crossICon: 'assets/images/cross-icon.svg',
  flightIcon: 'assets/images/flight-icon.svg',
  flightIconActive: 'assets/images/flight-selected-icon.svg',
  calenderIcon: 'assets/images/calender-icon.svg',
  featureIcon: 'assets/images/feature-icon.svg',
  featureIcon2: 'assets/images/feature-icon2.svg',
  featureIcon3: 'assets/images/feature-icon3.svg',
  srchIcon: 'assets/images/srch-icon.svg',
  insuranceIcon: 'assets/images/insurance-icon.svg',
  BradIcon: 'assets/images/brand-icon.svg',
  subCatIcon: 'assets/images/sub-cat-icon.svg',
  CatIcon: 'assets/images/cat-icon.svg',
  vehicleImg: 'https://esqyre.com/assets/images/car.jpg',
  infoIcon: 'assets/images/info-icon.svg',
  travelIcon: 'assets/images/travel-icon.svg',
  bookingSuccess: 'assets/images/booking-success-icon.svg',
  phoneIcon: 'assets/images/phn-icon.svg',
  mailIcon: 'assets/images/mail-icon.svg',
  envelopIcon: 'assets/images/envelope.svg',
  callIcon: 'assets/images/phone-flip.svg',
  loginImg: 'assets/images/login-img.svg',
  filterIcon: 'assets/images/filter-icon.svg',
  passwrdIcon: 'assets/images/eye-icon.svg',
  logOutIcn: 'assets/images/log-out-icn.svg',
  ChngPswdIcn: 'assets/images/chng-pswd-icn.svg',
  profileIcon: 'assets/images/profile-icon.svg',
  cameraIcon: 'assets/images/camera-icon.svg',
  NoClientAvail: 'assets/images/no-client-available.svg',
  NoEmployeeAvail: 'assets/images/no-employee-available.svg',
  NoTeamAvail: 'assets/images/no-team-available.svg',
  PhoneVerifyIcn: 'assets/images/phone-verify-icn.svg',
  emailVerifyIcn: 'assets/images/email-verify-icn.svg',
  dlteIcn: 'assets/images/dlt-icn.svg',
  noBookingAvail: 'assets/images/no-booking-icn.svg',
  noFineToll: 'assets/images/no-fineToll-icn.svg',
  noPayoutAvail: 'assets/images/no-payout-icn.svg',
  noSuadminAvail: 'assets/images/no-subadmin-available.svg',
  calenderDay: 'assets/images/calendar-day.svg',
  Car: 'assets/images/car.svg',
  Jet: 'https://esqyre.com/assets/images/jet.png',
  Villa: 'https://esqyre.com/assets/images/villa.jpg',
  Yatch: 'https://esqyre.com/assets/images/yatch.png',
  noNotifcationAvail: 'assets/images/no-notificaiton-icn.svg',
  trackIconWhite: 'assets/images/track-white-icn.svg',
  NopolicieICon: 'assets/images/no-Policy.svg',
  editBookingIcon: 'assets/images/edit-booking-icon.svg',
  editIIcon: 'assets/images/edit-icon.svg',
  ViewIcon: 'assets/images/view-icon.svg',
  delteIcon: 'assets/images/trash-icon.svg',
  warningIcon: 'assets/images/warning-icon.svg',
  calenderIconGrey: 'assets/images/calender-icon-grey.svg',
  ServiceIconGrey: 'assets/images/service-icon-grey.svg',
  LocIcon: 'assets/images/location-icon-grey.svg',
  approveImg: 'assets/images/approve.svg',
  copyLinkIcon: 'assets/images/copy-link-icon.svg',
  specialAccess: 'assets/images/special-access.svg',
  approvalIcon: 'assets/images/approva-queue-icon.png',
  WarehouseIcon: 'assets/images/warehouse-location.svg',
  dropOffImg: 'assets/images/dropOff-location.svg',
  NoDriverAvail: 'assets/images/no-driver-icn.svg',
  NoDocAvail: 'assets/images/no-doc-icn.svg',
  pickUpIcon: 'assets/images/pickup-location.svg',
  CurrentLocationIcon: 'assets/images/current-location.png',
  noFeatureIcon: 'assets/images/no-feature-icon.svg',
  lock: 'assets/images/lock.svg',
  star1Icon: 'assets/images/star-1.svg',
  whiteAddIcon: 'assets/images/white-add.svg',
  calendarIcon: 'assets/images/calendar-icon.svg',
  trendUp: 'assets/images/trending-up-24px.svg',
  trendDown: 'assets/images/trending-down-24px.svg',
  dollarCircleIcon: 'assets/images/dollar-circle-icon.svg',
  fileInvoiceDollar: 'assets/images/file-invoice-dollar.svg',
  carIcon: 'assets/images/car-icon.svg',
  cataloguesIcon: 'assets/images/catalogue.svg',
  powerIcon: 'assets/images/power.svg',
  speedIcon: 'assets/images/top-speed.svg',
  engineIcon1: 'assets/images/engine.svg',
  bathroomIcon: 'assets/images/bathroom.svg',
  bedroomIcon: 'assets/images/bedroom.svg',
  featureIcon1: 'assets/images/feature.svg',
  rangeIcon: 'assets/images/range.svg',
  personsIcon: 'assets/images/persons.svg',

  luxury1: 'https://da1vg7u84ubch.cloudfront.net/1779389293307-blob',
  luxury2: 'https://da1vg7u84ubch.cloudfront.net/1779389239173-blob',
  luxury3: 'https://da1vg7u84ubch.cloudfront.net/1779389331577-blob',
  luxury4: 'https://da1vg7u84ubch.cloudfront.net/1779389355643-blob',
  luxuryDetail1: 'https://da1vg7u84ubch.cloudfront.net/1779389128386-blob',
  luxuryDetail2: 'https://da1vg7u84ubch.cloudfront.net/1779389402573-blob',
  luxuryDetail3: 'https://da1vg7u84ubch.cloudfront.net/1779389452896-blob',
  luxuryDetail4: 'https://da1vg7u84ubch.cloudfront.net/1779389483405-blob',

  stay1: 'https://da1vg7u84ubch.cloudfront.net/1779391032049-blob',
  stay2: 'https://da1vg7u84ubch.cloudfront.net/1779391062603-blob',
  stay3: 'https://da1vg7u84ubch.cloudfront.net/1779391083179-blob',
  stay4: 'https://da1vg7u84ubch.cloudfront.net/1779391160114-blob',
  stayDetail1: 'https://da1vg7u84ubch.cloudfront.net/1779390909149-blob',
  stayDetail2: 'https://da1vg7u84ubch.cloudfront.net/1779390942538-blob',
  stayDetail3: 'https://da1vg7u84ubch.cloudfront.net/1779390970409-blob',
  stayDetail4: 'https://da1vg7u84ubch.cloudfront.net/1779390998044-blob',

  jet1: 'https://da1vg7u84ubch.cloudfront.net/1779391411923-blob',
  jet2: 'https://da1vg7u84ubch.cloudfront.net/1779391450476-blob',
  jet3: 'https://da1vg7u84ubch.cloudfront.net/1779391469341-blob',
  jet4: 'https://da1vg7u84ubch.cloudfront.net/1779391491109-blob',
  jetDetail1: 'https://da1vg7u84ubch.cloudfront.net/1779391278974-blob',
  jetDetail2: 'https://da1vg7u84ubch.cloudfront.net/1779391306165-blob',
  jetDetail3: 'https://da1vg7u84ubch.cloudfront.net/1779391328949-blob',
  jetDetail4: 'https://da1vg7u84ubch.cloudfront.net/1779391365203-blob',

  yacht1: 'https://da1vg7u84ubch.cloudfront.net/1779391670814-blob',
  yacht2: 'https://da1vg7u84ubch.cloudfront.net/1779391692559-blob',
  yacht3: 'https://da1vg7u84ubch.cloudfront.net/1779391717203-blob',
  yacht4: 'https://da1vg7u84ubch.cloudfront.net/1779391741059-blob',
  yachtDetail1: 'https://da1vg7u84ubch.cloudfront.net/1779391565790-blob',
  yachtDetail2: 'https://da1vg7u84ubch.cloudfront.net/1779391588750-blob',
  yachtDetail3: 'https://da1vg7u84ubch.cloudfront.net/1779391616279-blob',
  yachtDetail4: 'https://da1vg7u84ubch.cloudfront.net/1779391636308-blob',

  calendorFingerIcon: 'assets/images/analytics/calendor-finger.svg',
  dollarBagIcon: 'assets/images/analytics/dollar-bag.svg',
  dollarCalcIcon: 'assets/images/analytics/dollar-calc.svg',
  dollarPersonIcon: 'assets/images/analytics/dollar-person.svg',
  forgotPassImg: 'assets/images/forgot-pass.svg',

  driveType: 'assets/images/features/drive.svg',
  fuelType: 'assets/images/features/fuel.svg',
  luggageType: 'assets/images/features/luggage.svg',
  seatType: 'assets/images/features/seat.svg',
  speedType: 'assets/images/features/speed.svg',
  airbag: 'assets/images/features/airbag.svg',
  cylinders: 'assets/images/features/cylinders.svg',
  transmissionType: 'assets/images/features/transmission.svg',
  mileageLimitIcon: 'assets/images/features/mileage-limit.svg',
  door: 'assets/images/features/door.svg',
  color: 'assets/images/features/Color.png',

  currencyIconRed: 'assets/images/currency-icon-red.svg',
  currencyIconYellow: 'assets/images/currency-icon-yellow.svg',
  bankIcon: 'assets/images/bank-icon.svg',
  downloadIcon: 'assets/images/download-icon.svg',
  walletIcon: 'assets/images/wallet-icon.svg',

  departureIcon: 'assets/images/flight-icons/departures.png',
  arrivalIcon: 'assets/images/flight-icons/arrivals.png',
  arrivals: 'assets/images/flight-icons/arrivals.svg',
  departures: 'assets/images/flight-icons/departure.svg',
  departureLabel: 'assets/images/flight-icons/departure-label.svg',
  arrivalLabel: 'assets/images/flight-icons/arrival-label.svg',
  bookingModified: 'assets/images/booking-modified.png',
  noAlerts: 'assets/images/no-alerts.svg',
  lockedIcon: 'assets/images/locked-icon.svg',
  discountIcon: 'assets/images/discountIcon.png'
};
